<template>
  <div class="cart">
    <div v-if="review === 0" class="container">
      <div class="row">
        <div class="col-4"><button class="cart-buttons">Cart</button></div>
        <div class="col-4">
          <button
            class="cart-buttons"
            style="  background: linear-gradient(to left, #05cefc, #5659ce); color: #fff"
          >
            Billing
          </button>
        </div>
        <div class="col-4"><button class="cart-buttons">Review</button></div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-7 col-lg-7">
          <div class="title mt-5">
            <h4>Billing Address</h4>
          </div>
          <div class="mt-5 ml-4">
            <h3 style="margin-bottom:0" class="my-address">Information :</h3>
            <p style="margin-bottom:0" class="">{{ user.name }}</p>
            <p style="margin-bottom:0" class="">{{ user.email }}</p>
            <p style="margin-bottom:0" class="mb-4">{{ user.phone }}</p>

            <h3 style="margin-bottom:0" class="my-address">Address :</h3>
            <div class="form-grop mb-1">
              <label for="exampleFormControlTextarea1">Your Country</label>
              <input type="text" value="Iraq" disabled class="form-control" />
            </div>
            <div class="form-group mb-1">
              <label for="exampleFormControlTextarea1">Your Province</label>
              <multiselect
                v-model="provinceId"
                :options="provinces"
                :searchable="true"
                :close-on-select="true"
                :custom-label="nameWithLang"
                placeholder="Pick a Provance"
              ></multiselect>
            </div>
            <div v-if="provinceId != ''" class="form-group mb-1">
              <label for="exampleFormControlTextarea1">Your City</label>
              <multiselect
                v-model="cityId"
                :options="cites"
                :searchable="true"
                :close-on-select="true"
                :custom-label="nameWithLang"
                placeholder="Pick a Provance"
              ></multiselect>
            </div>
            <div class="form-group mb-1">
              <label for="exampleFormControlTextarea1">Your Address</label>
              <textarea
                v-model="address"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
              ></textarea>
            </div>
            <p v-if="error" style="color: red">{{ errorMessage }}</p>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-5 col-lg-5">
          <div class="title mt-5">
            <h4>Payment Method</h4>
          </div>
          <div class="payment-card mt-5">
            <div
              style="width: 80px;"
              class="image-container-card py-2 pl-2 ml-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:svgjs="http://svgjs.com/svgjs"
                version="1.1"
                width="100%"
                x="0"
                y="0"
                viewBox="0 0 64 64"
                style="enable-background:new 0 0 512 512"
                xml:space="preserve"
                class=""
              >
                <g>
                  <g xmlns="http://www.w3.org/2000/svg" id="Buy">
                    <path
                      d="M61,2H55a1,1,0,0,0-1,1v.382L51.869,2.316A3.014,3.014,0,0,0,50.528,2H35.872A3,3,0,0,0,34,2.658L29.819,6H13a1,1,0,0,0-1,1V23a1,1,0,0,0,1,1H43a1,1,0,0,0,1-1V15.448a9.026,9.026,0,0,0,7.943-.648L53.28,14l.72,0V15a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V3A1,1,0,0,0,61,2ZM14,22V8H37.929L36.808,9.122a3,3,0,0,0,4.242,4.242l.95-.95V22ZM52.994,12a.993.993,0,0,0-.509.143l-1.571.942a7.03,7.03,0,0,1-6.24.482L44,13.293V10.414l1.27-1.27.516.172a7.044,7.044,0,0,0,4.428,0l1.1-.367a1,1,0,0,0-.632-1.9l-1.1.368a5.029,5.029,0,0,1-3.162,0l-1.1-.368a1,1,0,0,0-1.023.242l-2,2h0L39.636,11.95a1,1,0,0,1-1.414,0,1,1,0,0,1,0-1.414l3.886-3.887a1,1,0,0,0-1.414-1.414L39.929,6H33.021l2.226-1.781A1,1,0,0,1,35.872,4H50.528a1.019,1.019,0,0,1,.447.105L54,5.618v6.375ZM60,14H56V4h4Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                    <path
                      d="M28,12a1,1,0,0,1,1,1h2a3,3,0,0,0-2-2.816V9H27v1.184A2.993,2.993,0,0,0,28,16a1,1,0,1,1-1,1H25a3,3,0,0,0,2,2.816V21h2V19.816A2.993,2.993,0,0,0,28,14a1,1,0,0,1,0-2Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                    <path
                      d="M22,14H20a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                    <path
                      d="M36,14H34a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                    <path
                      d="M43.458,49.773a2.989,2.989,0,0,0-4.1-1.1l-6.427,3.7A3,3,0,0,0,30,50H22.3l-.2-.134A10.968,10.968,0,0,0,10,49.8V49a1,1,0,0,0-1-1H3a1,1,0,0,0-1,1V61a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1v-.136l.934.62A2.98,2.98,0,0,0,12.61,62H27.46a2.922,2.922,0,0,0,1.5-.4l13.4-7.73a3.017,3.017,0,0,0,1.5-2.606A2.97,2.97,0,0,0,43.458,49.773ZM8,60H4V50H8Zm33.36-7.866L27.945,59.873A.931.931,0,0,1,27.46,60H12.61a.977.977,0,0,1-.557-.173L10,58.464V52a1,1,0,0,0,.554-.167l.454-.3a8.976,8.976,0,0,1,9.985,0l.453.3A1,1,0,0,0,22,52h8a1,1,0,0,1,0,2H24a1,1,0,0,0,0,2h6a2.976,2.976,0,0,0,1.981-.764L40.368,50.4a.968.968,0,0,1,.746-.1.994.994,0,0,1,.611.472.966.966,0,0,1,.135.488A1.011,1.011,0,0,1,41.36,52.134Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                    <path
                      d="M41,28H15a1,1,0,0,0-1,1V47a1,1,0,0,0,1,1H41a1,1,0,0,0,1-1V29A1,1,0,0,0,41,28ZM29,30v4H27V30ZM40,46H16V30h9v5a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V30h9Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                    <path
                      d="M22,40H18a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                    <path
                      d="M26,40H25a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                    <path
                      d="M22,43H18a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                    <path
                      d="M26,43H25a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
                      fill="#ffffff"
                      data-original="#000000"
                      style=""
                      class=""
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div
              v-if="delivary_price"
              style="font-weight: bolder"
              class="card-price mr-4"
            >
              {{ delivary_price | toCurrency }} IQD
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <button class="contnue-button" @click="MoveToCheckout">
          Confirm your billing information
        </button>
      </div>
    </div>
    <div v-if="review === 1" class="container">
      <div class="row">
        <div class="col-4"><button class="cart-buttons">Cart</button></div>
        <div class="col-4"><button class="cart-buttons">Billing</button></div>
        <div class="col-4">
          <button
            class="cart-buttons"
            style="  background: linear-gradient(to left, #05cefc, #5659ce); color: #fff"
          >
            Review
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-5 col-lg-5">
          <div class="title mt-5">
            <h4>Billing Adress</h4>
          </div>
          <div class="mt-5 ml-4">
            <h3 style="margin-bottom:0" class="my-address">Information :</h3>
            <p style="margin-bottom:0" class="">{{ user.name }}</p>
            <p style="margin-bottom:0" class="">{{ user.email }}</p>
            <p style="margin-bottom:0" class="mb-4">{{ user.phone }}</p>

            <h3 style="margin-bottom:0" class="my-address">Address :</h3>
            <div v-if="provinceId != ''" class="form-group mb-0">
              Iraq
            </div>
            <div class="form-group mb-0">
              {{ province }}
            </div>
            <div v-if="provinceId != ''" class="form-group mb-0">
              {{ city }}
            </div>
            <div v-if="address" class="form-group mb-0">
              {{ address }}
            </div>
            <div class="form-group my-3">
              <label style="font-weight: bold" for="exampleFormControlTextarea1"
                >If you have any notes , leave them here:
              </label>
              <textarea
                v-model="orderNotes"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-7 col-lg-7">
          <div class="title mt-5">
            <h4>Your Items</h4>
          </div>
          <div
            v-for="item in cart"
            :key="item._id"
            class="payment-card-second mt-5"
          >
            <div
              style="width: 80px; height: 80px"
              class="image-container-card py-2 pl-2"
            >
              <img
                width="100%"
                height="100%"
                :src="
                  'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                    item.product.images[0]
                "
              />
            </div>
            <div
              style="font-weight: bolder"
              class="card-price-second ml-2 mr-4"
            >
              {{ item.product.title }}
              <span
                style="color: black; font-size: 16px; font-weight: normal"
                v-if="(item.product.types || []).length > 0"
              >
                <br />{{ item.product.types[0].groupName }} :
                {{ item.product.types[0].value }}</span
              >
            </div>
            <div style="font-weight: bolder" class="card-price-second mr-4">
              {{ item.totalQuantities }} x
              {{
                (item.totalPriceAfterDiscounted / item.totalQuantities)
                  | toCurrency
              }}
            </div>
          </div>

          <h6 class="mt-2">
            Total Items Price: {{ total_price | toCurrency }} IQD
          </h6>
          <h6 class="mt-2">
            Delivery Price: {{ delivary_price | toCurrency }} IQD
          </h6>
          <h4 style="border-top: 2px solid #c1c2c5" class="mt-4 pt-2">
            Total: {{ (total_price + delivary_price) | toCurrency }} IQD
          </h4>
          <div class="promo-input mt-5">
            <label for="exampleFormControlinput1">Promo Code</label>

            <div
              class="form-group"
              style="display: flex; justify-content: center; align-items: center"
            >
              <input
                v-model="promo"
                class="form-control"
                id="exampleFormControlinput1"
              />
              <span class="ml-2" v-if="promoStatus != null">
                <img
                  v-if="promoStatus == 1"
                  src="https://img.icons8.com/emoji/48/000000/check-mark-emoji.png"
                />
              </span>
            </div>
            <!-- <button class="btn btn-info" @click="checkPromo">check promo</button> -->
          </div>
          <p v-if="error" style="color: red">{{ errorMessage }}</p>
        </div>
      </div>
      <div class="row mt-3">
        <button class="contnue-button" @click="checkout">
          Checkout
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import Multiselect from "vue-multiselect";

import axios from "axios";
export default {
  components: { Multiselect },
  data: () => {
    return {
      options: [
        "Select option",
        "options",
        "selected",
        "mulitple",
        "label",
        "searchable",
        "clearOnSelect",
        "hideSelected",
        "maxHeight",
        "allowEmpty",
        "showLabels",
        "onChange",
        "touched",
      ],
      errorMessage: "",
      error: false,
      delivary_price: "",
      cart: [],
      total_price: 0,
      user: [],
      review: 0,
      orderNotes: "",
      provinceId: "",
      cityId: "",
      address: "",
      province: "",
      city: "",
      promo: null,
      promoStatus: null,
      // cart: [],
      // total_price: 0
      provinces: [],
      cites: [],
    };
  },
  watch: {
    provinceId: function(val) {
      this.getCites(val._id);
      this.setDelivaryPrice(val._id);
      this.setProvince(val._id);
    },
    cityId: function(val) {
      this.setCity(val._id);
    },
  },
  created() {
    this.getProvinces();
    this.getUserProfile();
    this.getCart();
  },
  methods: {
    MoveToCheckout() {
      if (this.cityId != "" && this.provinceId != "" && this.address !== "") {
        this.error = false;
        this.errorMessage = "";
        this.review = 1;
      } else this.error = true;
      this.errorMessage = "please check your city and province";
    },
    getProvinces() {
      axios
        .get("https://api.ardunic.com/v1/provinces")
        .then((res) => (this.provinces = res.data.data));
    },
    getCites(id) {
      axios
        .get(`https://api.ardunic.com/v1/cities/${id}`)
        .then((res) => (this.cites = res.data.data));
    },
    getUserProfile() {
      axios
        .get("https://api.ardunic.com/v1/user", {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then((res) => (this.user = res.data.data));
    },
    nameWithLang({ title }) {
      return `${title}`;
    },
    getCart() {
      axios
        .get("https://api.ardunic.com/v1/cart", {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.cart = res.data.data;
          res.data.data.forEach((item) => {
            this.total_price += item.totalPriceAfterDiscounted;
          });
        });
    },
    // checkPromo(){
    //         axios.get(`https://api.ardunic.com/v1/coupon?promo=${this.promo}`,{
    //     headers: {
    //       access_token : localStorage.getItem('token')
    //     }
    //   }).then(res => {
    //       console.log(res);

    //   })
    // },
    setDelivaryPrice(id) {
      this.provinces.filter((prov) => {
        if (prov._id == id) return (this.delivary_price = prov.price);
      });
    },
    setProvince(id) {
      this.provinces.filter((prov) => {
        if (prov._id == id) return (this.province = prov.title);
      });
    },
    setCity(id) {
      this.cites.filter((city) => {
        if (city._id == id) return (this.city = city.title);
      });
    },
    async checkout() {
      let data = {
        orderNotes: this.orderNotes,
        location: {
          provinceId: this.provinceId._id,
          cityId: this.cityId._id,
          address: this.address,
        },
      };
      if (this.promo != "" && this.promo != null && this.promo != "") {
        data = {
          orderNotes: this.orderNotes,
          location: {
            provinceId: this.provinceId._id,
            cityId: this.cityId._id,
            address: this.address,
          },
          promo: this.promo,
        };
      }

      axios
        .post("https://api.ardunic.com/v1/order", data, {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          router.push(`/order-success/${res.data.data.orderId}`);
        })
        .catch((error) => {
          this.error = true;
          this.errorMessage = error.response.data.message;
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.cart {
  margin-top: 120px;
}

.title h4 {
  font-weight: bolder;
}

#chipss {
  background: linear-gradient(right, #ff3fbb, #ff8891);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

#chipss2 {
  background: linear-gradient(to right, #05cefc, #5659ce);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

.items-card {
  width: 100%;
  border-radius: 20px;
  border: 1px solid #c1c2c5;
}

.left-wing {
  display: flex;
  align-items: center;
}

.right-wing {
  margin-right: 15px;
}

.price h5 {
  color: rgb(26, 91, 211);
  text-align: right;
  font-size: 20px;
  font-weight: bolder;
}

.item-title h5 {
  font-weight: bold;
  margin-bottom: 15px;
}

.item-stock {
  font-size: 18px;
  letter-spacing: 1.6;
}
.info {
  margin-left: 10px;
}

.cart-buttons {
  width: 100%;
  padding: 20px 50px;
  border-radius: 30px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
}

.contnue-button {
  width: 100%;
  text-align: center;
  padding: 20px 50px;
  border-radius: 10px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  background: linear-gradient(to right, #09f7ff, #05f040);
  color: #fff;
}

.total-card {
  width: 50%;
  text-align: center;
  padding: 10px 50px;
  border-radius: 30px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  background: linear-gradient(to left, #05cefc, #5659ce);
  color: #fff;
}

.options-btn {
  width: 100px;
  border-radius: 30px;
  border: none;
  margin-left: 5px;
  background: #fff;
  border: 1px solid #c1c2c5;
}

.options {
  display: flex;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 10px 20px 10px;
}

.cart-item:not(:last-child) {
  border-bottom: 1px solid #c1c2c5;
}

.img-container {
  width: 250px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-container img {
  padding: 15px;
}

.my-address {
  font-weight: bolder;
}

.payment-card {
  width: 100%;
  height: 100px;
  background: linear-gradient(to left, #ff4254, #f177fd);
  color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-price-second {
  color: black;
}

.payment-card-second {
  width: 100%;
  height: 100px;
  color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px;
  border: 1px solid #c1c2c5;
}
</style>
